import React,{useEffect} from 'react';
import AppleLogin from 'react-apple-login';
import { useLocation ,useNavigate } from 'react-router-dom';
import appleImg from "../../../images/apple.png";
// import { APPLE_CLIENT_ID, APPLE_REDIRECT_URI } from '../../../config/api';

const WebAppleLogin = () => {
  const location = useLocation();
  console.log('component is called');
  const navigate = useNavigate();
const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID;
const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;


const handleAppleResponse = (response) => {
  console.log('Apple login successful12:', response);

  if (response && response.authorization) {
    const { code, id_token } = response.authorization;
    console.log('Authorization code:', code);
    console.log('ID Token:', id_token);

    // You can redirect or handle login flow here:
    window.location.href = `https://app.qushi.io/callback?code=${code}&id_token=${id_token}`;
  } else {
    console.error('Missing authorization data in the response.');
  }
};

  const handleAppleError = (error) => {
    console.error('Apple login error:', error);
  };


  const appleResponse = (response) => {
    if (!response.error) {
    } else {
      console.error("Apple Sign-In Error:", response.error);
    }
  };




  return (
    <div className='w-full'>
      <AppleLogin
        clientId={APPLE_CLIENT_ID} // Replace with your actual client ID
        redirectURI={APPLE_REDIRECT_URI} // Replace with your actual redirect URI
        responseType="code id_token"
        responseMode="query"
        usePopup={true}
        callback={handleAppleResponse}
        scope="email name"
        onError={handleAppleError}
        render={(props) => (
          <button
            onClick={props.onClick}
          className="mt-1 secondary-button text-black items-center h-11 border border-gray-300 justify-center flex w-full rounded-[16px]"
          >
                    {
            <img
              src={appleImg}
              className=" w-7 inline-block mx-1"
              alt="Google-logo"
            />
          }
            Continue with Apple
          </button>
        )}
      />
    {/* <AppleLogin
          clientId="io.qushi.app"
          redirectURI="https://qushi.techpss.com/callback"
          responseType="code id_token"
          responseMode="form_post"
          usePopup={false}
          callback={appleResponse} // Catch the response
          scope="email name"
          render={renderProps => (  //Custom Apple Sign in Button
                    <button
                      onClick={renderProps.onClick}
                      style={{
                            backgroundColor: "white",
                            padding: 10,
                            border: "1px solid black",
                            fontFamily: "none",
                            lineHeight: "25px",
                            fontSize: "25px"
                          }}
                        >
                          <i className="fa-brands fa-apple px-2 "></i>
                          Continue with Apple tarun
                    </button>
                      )}
  /> */}

      {/* <AppleSignin
        authOptions={{
          clientId: "io.qushi.app", // Your Service ID from Apple
          scope: "email name", // Requesting email and name
          redirectURI: "https://qushi.techpss.com/callback", // Must match Apple's settings
          usePopup: true, // Set to false to redirect instead of popup
        }}
        onSuccess={(response) => console.log("Success:", response)}
        onError={(error) => console.error("Error:", error)}
        render={(props) => (
          <button {...props} style={{ backgroundColor: "black", color: "white", padding: "10px 20px" }}>
            Sign in with Apple
          </button>
        )}
      /> */}

    </div>
  );
};

export default WebAppleLogin;
